import React from 'react';
import {observable, toJS} from 'mobx';
import {observer} from 'mobx-react';
import {withRouter} from 'react-router'

import ListTable from '@components/ListTable/ListTable.jsx';

import current_store, {
    filter_store,
    pagination_store,
    WalletItemStore
} from '@store/Statistic/WalletHistory/WalletHistoryStore';

@withRouter
@observer
class WalletListTable extends React.Component {
    constructor(props) {
        super();
    }

    componentWillReceiveProps(props) {

    }

    @observable
    filteredInfo = {
        pet_name: [],
        proxy_pet_name: []
    };

    clearFilter = () => {
        this.filteredInfo = {
            pet_name: [],
            proxy_pet_name: []
        };
    };

    reloadData() {
        //默认时间倒叙排序
        current_store.reloadDatas(this.props.Types);
    }


    componentDidMount() {
        this.reloadData();
    }


    componentWillUnmount() {
        filter_store.resetAttr();
    }

    /**
     * 分页器点击回调
     * @param {number} page
     * @param {number} size
     */
    pagination_callback(page, size, order_by) {
        current_store.searchByFilter({
            type: this.props.Types,
            page: page,
            page_size: size,
            ...order_by,
        })
    }

    //因为有筛选所以需要放这里
    columns = [
        {
            key: 'pay_time',
            sorter: true,
            title: '订单时间',
            dataIndex: 'pay_time',
            defaultSortOrder: 'descend'
        },
        {
            key: 'type',
            title: '类型',
            render(text, record, index) {

                let type = "充值";
                if (current_store.currentType == WalletItemStore.Type_Cash) {
                    type = '提现';
                }

                return (
                    <span>
            {type}
          </span>
                )
            }
        },
        {
            key: 'pet_name',
            sorter: true,
            title: '用户',
            className: 'column-money',
            dataIndex: 'pet_name'
        },
        {
            key: 'money',
            sorter: true,
            title: '金额',
            sortDirections: ['descend'],
            render(text, record, index) {

                let style = undefined;
                let title = undefined;

                if (current_store.currentType == WalletItemStore.Type_Recharge) {
                    style = {
                        color: '#c43827'
                    };
                    title = `+${record.money}`;
                } else {
                    style = {
                        color: '#1c9f6d'
                    };
                    title = `-${record.money}`;
                }

                return (
                    <span style={style}>
          {title}
        </span>
                )
            }
        },
        {
            key: 'id',
            sorter: true,
            title: '订单ID',
            dataIndex: 'id'
        }
    ];

    render() {


        return (
            <ListTable
                data_source={toJS(current_store.item_array)}
                columns={this.columns}
                pagination={
                    {
                        // 当前页
                        current: pagination_store.page_cur,
                        // 每页条数
                        pageSize: pagination_store.page_size,
                        // 总数据条数
                        total: pagination_store.data_total,
                        // 页码候选列表
                        pageSizeOptions: pagination_store.page_size_options,
                        // // 页码变化回调
                        // onChange:( next_page, size ) => {
                        //   this.pagination_callback(next_page, size)
                        // },
                        // // 每页显示条数回调
                        // onShowSizeChange: ( current, size ) => {
                        //   this.pagination_callback(current, size)
                        // }
                    }
                }
                onChange={

                    (pagination, filters, sorter) => {
                        let current = pagination.current;
                        let page_size = pagination.pageSize;

                        this.filteredInfo = {
                            ...filters
                        };


                        let order_by = undefined;
                        if (sorter.columnKey !== undefined) {
                            let desc = 0;
                            if (sorter.order == 'descend') {
                                desc = 1;
                            }
                            order_by = {
                                order: sorter.columnKey,
                                desc: desc
                            }
                        }

                        this.pagination_callback(current, page_size, order_by);
                    }
                }
            />
        )
    }
}

export default WalletListTable;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/WalletHistory/WalletHistoryListTable.jsx